import Layout from "@/components/Layout/Layout";
import { PrivateContent } from "@/components/PrivateContent/PrivateContent";
import { Purchase } from "@/features/subscription";
import Head from "next/head";
import type { ReactElement } from "react";

function PurchasePage() {
	return (
		<>
			<Head>
				<title>ケアミープレミアムの購入</title>
				<meta name="robots" content="noindex" />
			</Head>

			<PrivateContent afterLoginPath="/premium/purchase">
				<Purchase />
			</PrivateContent>
		</>
	);
}

PurchasePage.getLayout = function getLayout(page: ReactElement) {
	return <Layout hideHeader>{page}</Layout>;
};

export default PurchasePage;
